module.exports = __webpack_public_path__ + "static/media/homeitem9.46b75517.png";